import { render, staticRenderFns, recyclableRender, components } from "./payment-success.vue?vue&type=template&id=afe4df00&scoped=true&"
var renderjs
import script from "./payment-success.vue?vue&type=script&lang=js&"
export * from "./payment-success.vue?vue&type=script&lang=js&"
import style0 from "./payment-success.vue?vue&type=style&index=0&id=afe4df00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe4df00",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/payment-success/payment-success.vue"
export default component.exports